import{queueMicroTask as o}from"./queueMicroTask.js";var r=function(r){o((function(){requestAnimationFrame(r)}))};export{r as queueResizeObserver};
//# sourceMappingURL=queueResizeObserver.js.map
